export function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const [hh, mm, ss] = [hours, minutes, remainingSeconds].map(val => String(val).padStart(2, '0'));

  return `${hh}:${mm}:${ss}`;
}
